<template>
  <div class="uploadImg" @click="click">
    <div v-show="src == '' || src == null" class="el-upload el-upload--text el-upload el-upload--picture-card">
      <i class="el-icon-plus avatar-uploader-icon"></i>
      <input
        ref="uploadFile"
        type="file"
        @change="upimg"
        name="file"
        class="el-upload__input"
        :disabled="disabled"
      />
    </div>
    <div
      v-show="src != '' && src != null"
      class="el-image el-upload-list__item-thumbnail el-upload-list__item-actions"
    >
      <img :src="src" class="el-image__inner" style="object-fit: cover;" />
      <!---->
    </div>
  </div>
</template>

<script>
// <uploadimg v-model="url"></uploadimg>
import { uploadPartyPhoto } from "@/api/requrestHttp.js";
export default {
  name: "uploadImg",
  data() {
    return {
      src: ""
    };
  },
  props: {
    value: {
      default: ""
    },
    disabled: {
      default: false
    }
  },
  methods: {
    upimg(e) {
      let fd = new FormData();
      fd.append("file", e.target.files[0]);
      uploadPartyPhoto(fd)
        .then(res => {
          this.$emit("input", res.content);
          this.src = res.content;
          e.target.value = null;
        })
        .catch(error => {
          this.$message.error("上传失败");
        });
    },
    click() {
      // 触发文件上传
      this.$refs.uploadFile.click();
    }
  },
  mounted() {
    this.src = this.value;
  },
  updated() {},
  created() {},
  watch: {
    value: function(newVal, oldVal) {
      this.src = newVal;
    }
  }
};
</script>
<style lang="less" scoped>
.uploadImg {
  position: relative;
  width: 170px;
  height: 150px;
}
.el-image {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.el-upload--picture-card {
  width: 100%;
  height: 100%;
}
.avatar-uploader-icon {
  width: auto;
  height: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
